// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminQuotesPageContainer {
  width: 100%;
  position: relative;
  top: 0vh;
}

.adminQuotesPageHeader {
  color: #ffffff;
  font-size: 1.75rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
}

.adminQuotesTableWrapper {
  margin-top: 1rem;
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow-x: auto;
  padding: 8px;
}

.adminQuotesTable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  text-align: left;
}

.adminQuotesTable thead {
  background-color: #e2e2e2;
}

.adminQuotesTable th {
  color: #247a97;
  font-size: 1rem;
  padding: 8px;
  word-wrap: break-word;
}

.singleQuoteLine:hover {
  background-color: #e5e7eb;
}

.adminQuotesTableCell {
  padding: 8px;
  font-size: 1.25rem;
  vertical-align: middle;
  text-align: left;
  word-wrap: break-word;
}

.adminQuotesActionButton {
  padding: 8px 16px;
  background-color: #247a97;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

.adminQuotesActionButton:hover {
  background-color: #22c55e;
}

.adminQuotesPagination {
  display: flex;
  justify-content: center;
  padding-top: 16px;
}

.adminQuotesPaginationItem {
  padding: 8px;
  font-size: 1rem;
  margin: 0 4px;
  border-radius: 4px;
  background-color: white;
  border: 1px solid #cccccc;
}

.adminQuotesPaginationItem:hover {
  background-color: #e2e2e2;
}

.quoteDetails-container {
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.quoteDetailsHeading {
  font-size: 1.75rem;
  font-weight: bold;
  color: #247a97;
  text-align: center;
}

@media (max-width: 991px) {
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/AdminQuotePage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;AACA","sourcesContent":[".adminQuotesPageContainer {\n  width: 100%;\n  position: relative;\n  top: 0vh;\n}\n\n.adminQuotesPageHeader {\n  color: #ffffff;\n  font-size: 1.75rem;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.adminQuotesTableWrapper {\n  margin-top: 1rem;\n  background-color: #ffffff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow-x: auto;\n  padding: 8px;\n}\n\n.adminQuotesTable {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  text-align: left;\n}\n\n.adminQuotesTable thead {\n  background-color: #e2e2e2;\n}\n\n.adminQuotesTable th {\n  color: #247a97;\n  font-size: 1rem;\n  padding: 8px;\n  word-wrap: break-word;\n}\n\n.singleQuoteLine:hover {\n  background-color: #e5e7eb;\n}\n\n.adminQuotesTableCell {\n  padding: 8px;\n  font-size: 1.25rem;\n  vertical-align: middle;\n  text-align: left;\n  word-wrap: break-word;\n}\n\n.adminQuotesActionButton {\n  padding: 8px 16px;\n  background-color: #247a97;\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.adminQuotesActionButton:hover {\n  background-color: #22c55e;\n}\n\n.adminQuotesPagination {\n  display: flex;\n  justify-content: center;\n  padding-top: 16px;\n}\n\n.adminQuotesPaginationItem {\n  padding: 8px;\n  font-size: 1rem;\n  margin: 0 4px;\n  border-radius: 4px;\n  background-color: white;\n  border: 1px solid #cccccc;\n}\n\n.adminQuotesPaginationItem:hover {\n  background-color: #e2e2e2;\n}\n\n.quoteDetails-container {\n  padding: 16px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.quoteDetailsHeading {\n  font-size: 1.75rem;\n  font-weight: bold;\n  color: #247a97;\n  text-align: center;\n}\n\n@media (max-width: 991px) {\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
